import PropTypes from 'prop-types';
import { Avatar, Cushion, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import React from 'react';
import { Trans } from '../../lib/i18n';

const TrainingAttendees = ({ organiser, teams }) => (
  <Shadow>
    <Rectangle fill="white" radius="rounded">
      <Cushion
        className="training-attendees"
        all="large"
        style={{ gridArea: 'attendees' }}
        component="div"
      >
        <Typography preset="tab--active" component="h2">
          <Trans i18nKey="common:training_teams_attending">Teams attending</Trans>
        </Typography>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {teams.map((team) => (
            <Typography preset="body--large" component="li" key={team.id}>
              {team.name}
            </Typography>
          ))}
        </ul>

        {organiser && (
          <>
            <Typography preset="tab--active" component="h2">
              <Trans i18nKey="common:training_organiser">Organiser</Trans>
            </Typography>
            <Cushion all="small" component="div">
              <Shadow>
                <Avatar image={organiser.avatar} includeRetina alt={organiser.name} />
              </Shadow>
            </Cushion>
            <Typography preset="description" component="div">
              {organiser.name}
            </Typography>
          </>
        )}
      </Cushion>
    </Rectangle>
  </Shadow>
);

TrainingAttendees.defaultProps = {
  organiser: null,
};

TrainingAttendees.propTypes = {
  organiser: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
  }),
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};
export default TrainingAttendees;
